import React, { memo, SVGProps } from 'react'

export const SearchAI = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.5 3.50766C7.21979 3.50766 3.75 6.97745 3.75 11.2577C3.75 15.5379 7.21979 19.0077 11.5 19.0077C15.7802 19.0077 19.25 15.5379 19.25 11.2577C19.25 6.97745 15.7802 3.50766 11.5 3.50766ZM2.25 11.2577C2.25 6.14903 6.39137 2.00766 11.5 2.00766C16.6086 2.00766 20.75 6.14903 20.75 11.2577C20.75 16.3663 16.6086 20.5077 11.5 20.5077C6.39137 20.5077 2.25 16.3663 2.25 11.2577Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.4697 17.2273C17.7626 16.9344 18.2374 16.9344 18.5303 17.2273L21.5303 20.2273C21.8232 20.5202 21.8232 20.9951 21.5303 21.288C21.2374 21.5809 20.7626 21.5809 20.4697 21.288L17.4697 18.288C17.1768 17.9951 17.1768 17.5202 17.4697 17.2273Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.90827 8.0401C8.93323 8.0401 8.14149 8.83183 8.14149 9.80688V15.4355C8.14149 15.8497 7.80571 16.1855 7.39149 16.1855C6.97728 16.1855 6.64149 15.8497 6.64149 15.4355V9.80688C6.64149 8.0034 8.1048 6.5401 9.90827 6.5401C11.7118 6.5401 13.1751 8.0034 13.1751 9.80688V15.4355C13.1751 15.8497 12.8393 16.1855 12.4251 16.1855C12.0108 16.1855 11.6751 15.8497 11.6751 15.4355V9.80688C11.6751 8.83183 10.8833 8.0401 9.90827 8.0401Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.64149 11.3617C6.64149 10.9475 6.97728 10.6117 7.39149 10.6117H12.4251C12.8393 10.6117 13.1751 10.9475 13.1751 11.3617C13.1751 11.7759 12.8393 12.1117 12.4251 12.1117H7.39149C6.97728 12.1117 6.64149 11.7759 6.64149 11.3617Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.3579 6.5401C15.7722 6.5401 16.1079 6.87589 16.1079 7.2901V15.4355C16.1079 15.8497 15.7722 16.1855 15.3579 16.1855C14.9437 16.1855 14.6079 15.8497 14.6079 15.4355V7.2901C14.6079 6.87589 14.9437 6.5401 15.3579 6.5401Z"
      fill="currentColor"
    />
  </svg>
))
